
const UseTermsTR = () => (
  <>
    <h3>Termos e Condições Gerais de Uso do Sistema Legal One Analytics</h3>

    <p>
      Os serviços do sistema
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      são fornecidos pela
      {' '}
      <b>Juristec</b>
      {' '}
      Sistemas Jurídicos Integrados Ltda ("
      <b>Juristec</b>
      "), pessoa
      jurídica de direito privado, inscrita no CNPJ/MF sob o nº 27.434.472/0001-09, titular
      da propriedade intelectual sobre entre outros ativos relacionados à plataforma
      {' '}
      <b>Legal One Analytics</b>
      . Referidos serviços são disponibilizados aos usuários pela
      {' '}
      <b>Thomson Reuters Brasil</b>
      {' '}
      Conteúdo e Tecnologia Ltda ("
      <b>Thomson Reuters</b>
      "), pessoa jurídica de direito privado,
      inscrita no CNPJ/MF sob o nº 00.910.509/0001-71, por meio de parceria firmada entre
      {' '}
      <b>Juristec</b>
      {' '}
      e
      {' '}
      <b>Thomson Reuters</b>
      .
    </p>

    <h3 className="section">1. Do Objeto</h3>
    <p>
      A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de
      propriedade intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia a dia dos
      seus usuários.
    </p>
    <p>
      A plataforma caracteriza-se pela prestação dos serviços de “business intelligence” jurídico,
      que pode ser qualificado como um sistema de processamento de bases de dados na forma de
      relatórios e transformação dos mesmos em modelos gráficos por meio da aplicação de
      templates, cópia de dashboards ou criação de novos indicadores.
    </p>
    <p>
      A plataforma é comercializada através do site de sua provedora
      {' '}
      <a
        href="https://www.thomsonreuters.com.br/pt/juridico/legal-one.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.thomsonreuters.com.br/pt/juridico/legal-one.html
      </a>
      {' '}
      e acessada através do site da URL
      {' '}
      <a
        href="https://legalone-analytics.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://legalone-analytics.com.br
      </a>
      .
    </p>

    <h3 className="section">2. Da Aceitação</h3>
    <p>
      O presente Termo estabelece obrigações contratadas de livre e espontânea vontade,
      entre a plataforma e as pessoas físicas ou jurídicas, usuárias do software
      {' '}
      <b>Legal One Analytics</b>
      .
    </p>
    <p>
      Ao utilizar a plataforma
      {' '}
      <b>Legal One Analytics</b>
      , o usuário aceita integralmente as presentes normas e compromete-se a observá-las.
    </p>
    <p>
      A aceitação do presente instrumento é imprescindível para o acesso e para a utilização de
      quaisquer serviços fornecidos pela empresa. Caso não concorde com as disposições deste
      instrumento, o usuário não deve utilizá-los.
    </p>

    <h3 className="section">3. Do Acesso Dos Usuários</h3>
    <p>
      Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma
      para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por
      semana. No entanto, a navegação na plataforma ou em alguma de suas páginas poderá ser
      interrompida, limitada ou suspensa para atualizações, modificações, ações necessárias ao
      seu bom funcionamento e/ou por força de terceiros.
    </p>

    <h3 className="section">4. Do Cadastro</h3>
    <p>
      O acesso às funcionalidades da plataforma exigirá a realização de um cadastro prévio e, a
      depender dos serviços ou produtos escolhidos, o pagamento de determinado valor.
    </p>
    <p>
      Ao se cadastrar, o usuário deverá informar dados completos, recentes e válidos, sendo de sua
      exclusiva responsabilidade manter referidos dados atualizados, bem como o usuário se
      compromete com a veracidade dos dados fornecidos.
    </p>
    <p>
      O usuário se compromete a não informar seus dados cadastrais e/ou de acesso à plataforma a
      terceiros, responsabilizando-se integralmente pelo uso que deles seja feito.
    </p>
    <p>
      Menores de 18 anos e aqueles que não possuírem plena capacidade civil deverão obter
      previamente o consentimento expresso de seus responsáveis legais para utilização da
      plataforma e dos serviços ou produtos, sendo de responsabilidade exclusiva dos mesmos o
      eventual acesso por menores de idade e por aqueles que não possuem plena capacidade civil
      sem a prévia autorização.
    </p>
    <p>
      Mediante a realização do cadastro o usuário declara e garante expressamente ser plenamente
      capaz, podendo exercer e usufruir livremente dos serviços e produtos.
    </p>
    <p>
      Após a confirmação do cadastro, o usuário possuirá um login e uma senha pessoal
      disponibilizada pela
      {' '}
      <b>Thomson Reuters</b>
      , a qual assegura ao usuário o acesso individual
      à mesma. Desta forma, compete ao usuário exclusivamente a manutenção de referida senha
      de maneira confidencial e segura, evitando o acesso indevido às informações pessoais.
    </p>
    <p>
      Toda e qualquer atividade realizada com o uso da senha será de responsabilidade do usuário,
      que deverá informar prontamente a plataforma em caso de uso indevido da respectiva senha.
    </p>
    <p>
      Caberá ao usuário assegurar que o seu equipamento seja compatível com as características
      técnicas que viabilize a utilização da plataforma e dos serviços ou produtos.
    </p>
    <p>
      O usuário poderá requerer o cancelamento de seu cadastro junto ao sistema
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      diretamente à
      {' '}
      <b>Thomson Reuters</b>
      .
    </p>
    <p>
      O usuário, ao aceitar os Termos e Condições Gerais de Uso do Sistema
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      e o Termo de consentimento de Tratamento de Dados Pessoais, autoriza expressamente a
      plataforma a coletar, usar, armazenar, tratar, ceder ou utilizar as informações derivadas
      do uso dos serviços, do site e suas plataformas, incluindo informações preenchidas pelo
      usuário no momento em que realizar ou atualizar seu cadastro, além de outras, incluindo
      informações relacionadas a dados pessoais nas hipóteses e condições definidas no Termo
      de Consentimento de Tratamento de Dados Pessoais e na Política de Privacidade da
      {' '}
      <b>Juristec</b>
      .
    </p>

    <h3 className="section">5. Dos Serviços ou Produtos</h3>
    <p>
      A plataforma poderá disponibilizar para o usuário um conjunto específico de funcionalidades
      e ferramentas para otimizar o uso dos serviços e produtos.
    </p>
    <p>
      Os serviços ou produtos oferecidos estarão descritos no site da provedora:
      {' '}
      <a
        href="https://www.thomsonreuters.com.br/pt/juridico/legal-one.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.thomsonreuters.com.br/pt/juridico/legal-one.html
      </a>
      {' '}
      e nas documentações competentes, contendo informações sobre suas características,
      qualidades, quantidades, composição, preço, garantia, prazos de validade e origem,
      entre outros dados, bem como sobre os riscos que apresentam à saúde e segurança do
      usuário.
    </p>
    <p>
      Antes de finalizar a compra sobre determinado produto ou serviço, o usuário deverá se
      informar sobre as suas especificações e sobre a sua destinação.
    </p>

    <h3 className="section">6. Características do Legal One Analytics</h3>
    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      consiste em um software as a service (SAAS) de Business Intelligence desenvolvido para o setor
      jurídico. Ele permite integrar dados de diversas fontes, como relatórios de ERPs jurídicos,
      planilhas internas ou na nuvem e tabelas SQL e transformá-los em dashboards com indicadores
      estratégicos.
    </p>
    <p>
      O sistema recebe e processa apenas dados estruturados, os quais devem ser encaminhados pela
      CONTRATANTE no formato de tabelas CSV (comma-separated values) ou XLSX (Excel Microsoft Office
      Open XML Format Spreadsheet) ou integradas com relatórios de ERPs jurídicos utilizados pela
      CONTRATANTE ou ainda tabelas extraídas de bancos SQL ou planilhas armazenadas na nuvem.
    </p>
    <p>
      Os tipos de dados a serem inseridos pela CONTRATANTE disponíveis nas diversas fontes de dados,
      para inclusão no Legal One Analytics deverão observar os seguintes formatos:
    </p>
    <ul>
      <li>
        <b>Número:</b>
        {' '}
        dado que representa um valor numérico. Poderá ser um número inteiro (integer) ou real (ponto
        flutuante float). Em geral, independente de como os dados são apresentados na interface do
        usuário com os demais sistemas (ERPs ou nuvem), os dados são formatados com “ponto” (“.”)
        como delimitador decimal. No caso de utilização do Google Spreadsheets ou Microsoft One
        Drive, qualquer formatação numérica tende a ser aceita (aqui estamos nos referindo a
        delimitador decimal, separador de milhar, formatação monetária, entre outras).
      </li>
      <li>
        <b>Texto:</b>
        {' '}
        variável categórica que representa uma informação qualitativa. É considerada uma sequência
        contínua de caracteres ASCII.
      </li>
      <li>
        <b>Data:</b>
        {' '}
        variável do tipo data que devem ser recebidas nos formatos AAAA-MM-DD ou DD/MM/AAAA.
      </li>
    </ul>
    <p>
      Os dados que não estejam no formato especificado poderão não ser aceitos pelo
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      , que não processará integralmente o arquivo que os contém e indicará ao usuário o motivo
      do não processamento.
    </p>
    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      permite que o usuário, no momento da importação dos dados, ou em qualquer outro momento
      após a importação, possa alterar o tipo das colunas das tabelas disponíveis no sistema.
    </p>
    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      é uma aplicação que opera em ambiente computacional virtualizado da JURISTEC+, e é
      utilizada através de navegadores da web (Safari versão 13.0.3, ou superior; Internet
      Explorer versão 11, ou superior; Chrome versão 78.0.3904.70, ou superior, e Firefox versão
      48.0. 51.0.1, ou superior).
    </p>

    <h3 className="section">6.1. Tipos de Usuários</h3>
    <p>
      Há três tipos de perfis de usuários do
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      :
    </p>
    <ul>
      <li>
        <b>Convidado:</b>
        {' '}
        apto a visualizar, realizar download de relatórios e imprimir os dashboards que são
        compartilhados com ele.
      </li>
      <li>
        <b>Cientista:</b>
        {' '}
        apto a carregar (upload) as tabelas de dados, validar as informações, definir, criar
        e visualizar dashboards e  KPIs, criar e exportar os relatórios.
      </li>
      <li>
        <b>Usuário proprietário:</b>
        {' '}
        apto a gerenciar usuários e grupos no sistema, carregar (upload) as bases de dados,
        validar as informações, definir, criar e visualizar dashboards e KPIs, criar e exportar
        relatórios e configurar os relatórios de atualização automática.
      </li>
    </ul>
    <p>
      Ao contratar o
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      , é definido o usuário proprietário e as quantidades de usuários Cientistas e Convidados,
      como parte do plano contratado pela CONTRATANTE.
    </p>
    <p>
      A CONTRATANTE poderá contratar junto à Thomson Reuters quantidades adicionais de usuários
      proprietários, cientistas ou usuários convidados para o Legal One Analytics, conforme
      política de preços definida pela Thomson Reuters.
    </p>

    <h3 className="section">6.2. Instalação do Legal One Analytics</h3>
    <p>
      Ao término do processo de instalação do Legal One Analytics, a CONTRATANTE estará apta a
      utilizá-lo com o conjunto inicial de informações disponibilizadas.
    </p>
    <p>
      A instalação do
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      à CONTRATANTE consiste na adoção das seguintes etapas de trabalho:
    </p>
    <ul>
      <li>
        Criação da instância do
        {' '}
        <b>Legal One Analytics</b>
        {' '}
        específica para a CONTRATANTE com os respectivos recursos computacionais alocados;
      </li>
      <li>
        Importação e integração das informações iniciais fornecidas pela CONTRATANTE, seja a partir
        de tabelas de dados internas, tabelas de dados extraídas de bases SQL, ou através de
        relatórios de dados gerados pelo Legal One.
      </li>
      <li>
        Configuração dos KPIs e dashboards iniciais, como previsto no plano contratado pela
        CONTRATANTE, para a utilização imediata;
      </li>
      <li>
        Reunião de treinamento do sistema para as pessoas selecionadas pela CONTRATANTE.
      </li>
    </ul>
    <p>
      A plataforma
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      poderá disponibilizar aos usuários os seguintes treinamentos de utilização:
    </p>
    <ul>
      <li>
        <b>Treinamento Onboarding:</b>
        {' '}
        A ser usufruído durante os 3 primeiros meses de contrato para conhecimento da plataforma do
        {' '}
        <b>Legal One Analytics</b>
        {' '}
        . O cliente receberá um link de agenda e selecionará os horários de acordo com a
        disponibilidade de agenda.
      </li>
      <li>
        <b>Treinamento Ongoing:</b>
        {' '}
        A ser usufruído após os 3 primeiros meses e até o final da vigência.
      </li>
    </ul>

    <h3 className="section">6.3. Configurações adicionais</h3>
    <p>
      A CONTRATANTE poderá contratar configurações adicionais disponibilizadas pela Thomson Reuters
      (“ADD ONs”), especificados conforme condições  abaixo
    </p>
    <ul>
      <li>
        <b>Memória Virtual:</b>
        {' '}
        Disponibilização complementar de memória virtual. A memória será utilizada para a
        armazenagem das informações carregadas pela CONTRATANTE, pelos indicadores-chave (KPIs) e
        dashboards construídos, conforme política de preços da Thomson Reuters.
      </li>
    </ul>
    <p>
      A CONTRATANTE poderá contratar serviços adicionais disponibilizados pela Thomson Reuters,
      especificados conforme abaixo:
    </p>
    <ul>
      <li>
        <b>Dashboards Personalizados:</b>
        {' '}
        Refere-se ao serviço de elaboração de dashboards sob demanda, ou seja, personalizados de
        acordo com os interesses específicos da CONTRATANTE, conforme política de preços da
        Thomson Reuters. A execução deste serviço está condicionada à existência de uma base de
        dados disponível da CONTRATANTE. Não está incluído neste serviço nenhum trabalho adicional
        de construção, preparação ou saneamento de uma base de dados. Após a contratação deste
        serviço, a equipe Thomson Reuters fará a avaliação da demanda e, em caso de não
        possibilidade de cumprimento, o serviço não será realizado e, consequentemente, nada será
        cobrado.
      </li>
      <li>
        <b>Consultoria Exclusiva:</b>
        {' '}
        Serviços complementares de consultoria especializada em jurimetria, conforme política de
        preços da Thomson Reuters. A execução deste serviço deverá ser acompanhada de reunião
        prévia entre a CONTRATANTE e a equipe especializada da Thomson Reuters para avaliação da
        viabilidade técnica e disponibilidade de dados prévios para sua execução.
      </li>
    </ul>

    <h3 className="section">6.4. Funcionalidades</h3>

    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      simplifica a organização e análise das informações jurídicas através da geração de KPIs,
      validação de base de dados de informações e geração de dashboards para gestão de carteiras
      jurídicas.
    </p>
    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      permite, dentre outras finalidades:
    </p>
    <ul>
      <li>
        atualização automática dos KPIs, conforme as mudanças da base e utilização dos procedimentos
        salvos. Essa funcionalidade permite que o trabalho de execução de um dashboard seja
        realizado uma única vez para depois, ser atualizado constantemente, conforme a fonte das
        informações sejam alteradas (tabelas do ERP, tabelas da nuvem, alterações dos arquivos do
        dispositivo do usuário, entre outras);
      </li>
      <li>
        disponibilizar KPIs jurídicos prontos e agrupados em dashboards, como por exemplo:
        “Trabalhista”, “Cível”, “Acordos”, “Financeiro”, Estratégico”, entre outros;
      </li>
      <li>
        criar livremente KPIs em diversas combinações;
      </li>
      <li>
        gerar gráficos que possuem filtros na própria interface do dashboard ou KPI;
      </li>
      <li>
        realizar funções matemáticas que permitem a implantação de jurimetria financeira.
      </li>
      <li>
        possibilidade de realização de download dos arquivos e bases do sistema, assim como dos
        relatórios filtrados responsáveis pelos diversos KPIs criados. Todos os KPIs podem ser
        exportados no formato de figura (extensão PNG) para que sejam utilizados em apresentações
        externas.
      </li>
      <li>
        Criação de relatórios customizados a partir das bases de dados importadas no sistema.
      </li>
      <li>
        O sistema possui um tracking de todos os arquivos, dashboards e KPIs de forma que é
        possível verificar os responsáveis pela criação, as últimas atualizações e o passo a passo
        utilizado para a criação dos KPIs.
      </li>
      <li>
        Possibilidade de criação de histórico de base de dados, permitindo a comparação de mudanças
        na base ao longo do tempo nos diversos períodos em que os históricos foram armazenados.
      </li>
      <li>
        Possibilidade de compartilhamento de dashboards externamente, permitindo que terceiros
        interessados possam visualizar dashboards executivos de forma simples e intuitiva.
      </li>
      <li>
        O sistema possui um sistema de suporte interno que permite que o usuário crie tickets com
        dúvidas que serão prontamente respondidas pelo time técnico da Thomson Reuters.
      </li>
    </ul>

    <h3 className="section">6.5. Interface com os usuários</h3>
    <p>
      O
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      possui as seguintes interfaces para os usuários:
    </p>
    <ul>
      <li>
        <b>Interface de Dashboards:</b>
        {' '}
        Apresenta todos os dashboards próprios de um usuário ou os
        dashboards compartilhados por outros usuários. Nesta interface, os usuários podem criar
        novos dashboards, compartilhar seus próprios dashboards, clonar dashboards, apagar
        dashboards, acessar e filtrar informações, entre outras funcionalidades.
      </li>
      <li>
        <b>Interface de Arquivos:</b>
        {' '}
        Repositório de arquivos do sistema. Aqui são inseridas as diversas fontes de dados a
        partir das quais o usuário pode criar seus dashboards e KPIs. Cada arquivo é identificado
        conforme a sua fonte de origem. Os arquivos que o usuário insere de seu próprio dispositivo
        somente são atualizados quando o usuário atualizar as fonte de dados correspondentes. As
        demais fontes de dados integradas (ERPs, Google Sheets, One Drive, tabelas SQL, entre
        outras) são atualizadas diariamente de forma automática ou por necessidade do próprio
        usuário. Também é permitida a criação e gerenciamento de relatórios extraídos das bases de
        dados dos usuários.
      </li>
      <li>
        <b>Interface do dashboard:</b>
        {' '}
        Interface que apresenta o conjunto dos KPIs que constituem cada um dos dashboards do usuário
        ou de um dashboard compartilhado com este usuário.
      </li>
      <li>
        <b>Interface de Criação de KPI:</b>
        {' '}
        Interface que permite a criação dos KPIs a partir da seleção de variáveis de um arquivo,
        incorporando filtros e agrupamentos e estilos. Permite a seleção do tipo de gráfico e sua
        pré-visualização.
      </li>
      <li>
        <b>Interface de Gerenciamento da instância:</b>
        {' '}
        Interface onde os usuários proprietários e cientistas podem gerenciar os usuários atuais do
        sistema e/ou criar novos usuários. Nesta interface são listados todos os usuários, é
        possível fazer o bloqueio ou remoção de um usuário existente ou criar novos usuários para a
        utilização da ferramenta. Os usuários proprietários podem criar e gerenciar grupos inteiros
        de usuários, como por exemplo, replicando departamentos existentes em sua própria
        instituição.
      </li>
    </ul>

    <h3 className="section">6.6. Acordo de Nível de Serviço</h3>
    <p>
      Estão previstos os seguintes níveis de serviço para a utilização do
      {' '}
      <b>Legal One Analytics</b>
      {' '}
      :
    </p>
    <ul>
      <li>
        <b>Instalação do Legal One Analytics:</b>
        {' '}
        O tempo máximo para instalação do
        {' '}
        <b>Legal One Analytics</b>
        {' '}
        será de 15 (quinze) dias úteis a contar do recebimento da solicitação pela equipe da
        JURISTEC+. O tempo de 15 (quinze) dias está condicionado à disponibilização, por parte do
        cliente, de todo e qualquer arquivo e/ou documentação necessária para o onboarding inicial
        do sistema. Importante ressaltar que neste período de 15 (quinze) dias, não estão incluídos
        serviços adicionais de integração com novos sistemas (J+ integra) e que podem depender de
        situações externas ao controle da JURISTEC+ ou que dependam de terceiros.
      </li>
      <li>
        <b>Instalação de Dashboards Personalizados:</b>
        {' '}
        Tempo de entrega de até 2 (duas) semanas, limitado a 20 KPIs, podendo o prazo ser estendido
        a depender de atraso por conta da CONTRATANTE. O prazo para a entrega de dashboards
        personalizados está condicionado à disponibilidade, por parte da CONTRATANTE, dos arquivos
        e/ou tabelas completas. Enquanto os arquivos ou tabelas estiverem indisponíveis ou
        incompletos esta tarefa não será executada.
      </li>
      <li>
        <b>Elaboração de Relatórios Integrados:</b>
        {' '}
        Tempo de entrega entre 2 (duas) até 4 (quatro) semanas. Entrega condicionada à viabilidade
        técnica a ser apreciada pela equipe da JURISTEC+. Não sendo possível a integração, não
        caberá nenhuma contrapartida ou indenização a quaisquer das partes.
      </li>
      <li>
        <b>Solicitação de Acesso Individual:</b>
        {' '}
        Para garantir a melhor extração de dados e correção de eventuais erros a CONTRATANTE deverá
        fornecer um acesso do ERP utilizado para a CONTRATADA. Caso não seja possível a liberação do
        acesso, é de responsabilidade do CONTRATANTE viabilizar meios para execução do serviço.
      </li>
    </ul>

    <h3 className="section">7. Das Limitações de Responsabilidade</h3>
    <p>
      Exceto pelas garantias especificamente previstas no presente Contrato, a Thomson Reuters não
      concede garantias adicionais quanto ao uso dos softwares ora licenciados. A Thomson Reuters não
      realizará e nem concede qualquer garantia de adequação, customização e/ou parametrização dos
      softwares ora contratados com qualquer sistema da CONTRATANTE.
    </p>
    <p>
      A Thomson Reuters também não garante o uso ininterrupto dos softwares, considerando a
      dependência de serviços de telecomunicações prestados por terceiros e tendo em vista a
      impossibilidade de funcionamento integral e ininterrupto de qualquer sistema de telecomunicação
      ou de informática, durante 365 (trezentos e sessenta e cinco) dias por ano, 24 (vinte e quatro)
      horas por dia e nem que os softwares estarão isentos de erros.
    </p>
    <p>
      Caso a interrupção dos serviços tenha ocorrido em razão de falhas nos sistemas e ferramentas
      da CONTRATADA e, caso o restabelecimento do sistema não ocorra no prazo máximo de 48 (quarenta
      e oito) horas, a CONTRATANTE fará jus ao abatimento proporcional na fatura do mês,
      correspondente ao período de indisponibilidade do sistema.
    </p>
    <p>
      Os softwares contratados poderão sofrer interrupções de até 48 (quarenta e oito) horas por mês
      para manutenções e atualizações, desde que previamente informado à CONTRATANTE mediante
      notificação por e-mail ou aviso na própria plataforma. As manutenções e atualizações, quando
      necessárias, deverão ser realizadas preferencialmente fora do horário comercial e em finais de
      semana, não integrando as hipóteses de abatimento na fatura constantes da cláusula acima.
    </p>
    <p>
      A Thomson Reuters não se responsabilizará pela preparação ou adequação das bases de dados da
      própria CONTRATANTE a serem utilizadas nos softwares.
    </p>
    <p>
      A CONTRATANTE declara ter ciência de que NENHUM DOS SOFTWARES E/OU SERVIÇOS ORA CONTRATADOS
      SUBSTITUEM A NECESSIDADE DE ACOMPANHAMENTO JURÍDICO ÀS ATIVIDADES DA CONTRATANTE. Os softwares
      contratados são automatizados e têm a finalidade de apenas facilitar a análise de dados e
      informações disponibilizados pela própria CONTRATANTE e/ou obtidos de fontes públicas. A
      Thomson Reuters não se responsabiliza por erro de dados e/ou informações vindos da própria
      CONTRATANTE ou obtidos de fontes públicas, nem por quaisquer falhas na captura de tais dados e
      informações. Nenhuma informação ou dado disponibilizados nos softwares da Thomson Reuters têm a
      função de substituir informações oficiais vindas de fontes públicas, incluindo, mas não se
      limitando, a informações vindas de tribunais de justiça, diários oficiais e demais entidades
      da administração pública direta ou indireta, não servindo as plataformas da Thomson Reuters como
      instrumentos para controle de prazos processuais e recebimento de citação.
    </p>

    <h3 className="section">8. Da Confidencialidade</h3>
    <p>
      Informação Confidencial. Considera-se como “Informação Confidencial” quaisquer informações e
      dados revelados por uma parte (“Parte Divulgadora”), incluindo seus administradores,
      consultores, auditores, contadores, advogados, contratados, representantes ou empregados,
      podendo ser tangíveis ou intangíveis, transmitidos de qualquer forma, modificados ou não pela
      parte contrária (“Parte Receptora”), incluindo, mas não limitando-se a informações
      disponibilizadas pela Parte Divulgadora à Parte Receptora para inserção nas plataformas dos
      softwares contratados e demais dados, materiais e documentos que venham ser disponibilizados
      pela Parte Divulgadora à Parte Receptora em razão do presente Contrato.
    </p>
    <p>
      Não são consideradas Informações Confidenciais as informações que:
    </p>
    <ol type="I">
      <li>
        forem de conhecimento público ou assim se tornarem de forma outra que não pela divulgação
        pela Parte Receptora;
      </li>
      <li>
        já forem de conhecimento da Parte Receptora quando de sua divulgação pela Parte Divulgadora;
      </li>
      <li>
        forem divulgadas à Parte Receptora por outra fonte que não a Parte Divulgadora, desde que
        tal divulgação não tenha sido feita, no melhor conhecimento da Parte Receptora, em violação
        à obrigação de confidencialidade.
      </li>
    </ol>
    <p>
      A Parte Receptora ficará sujeita às seguintes obrigações:
    </p>
    <ol type="I">
      <li>
        não utilizar as Informações Confidenciais em proveito próprio ou para finalidade outra que
        não àquelas relacionadas ao objeto deste Contrato;
      </li>
      <li>
        manter as Informações Confidenciais em sigilo, divulgando-as apenas a seus administradores,
        empregados, prepostos, sócios, advogados, auditores e demais prestadores de serviços que
        necessitem receber as Informações Confidenciais para fins de avaliação, negociação e
        realização do presente Contrato, durante toda a vigência do presente Contrato e pelo
        período adicional de 5 (cinco) anos do seu término; e
      </li>
      <li>
        zelar pela manutenção do sigilo das Informações Confidenciais, tomando medidas razoáveis
        para proteger sua integridade e evitar sua divulgação.
      </li>
    </ol>
    <p>
      A Parte Receptora poderá divulgar quaisquer Informações Confidenciais caso assim requerido
      pela legislação ou regulamentação a que estiver sujeita, ou por ordem ou decisão judicial,
      administrativa ou arbitral. Neste caso, as Informações Confidenciais divulgadas deverão ser
      as mínimas necessárias para cumprimento da respectiva norma, ordem ou decisão, devendo a
      outra Parte ser informada, quando tal ato não implicar em violação legal.
    </p>

    <h3 className="section">9. Das Obrigações de Integridade</h3>
    <p>
      As partes declaram que cumprem e cumprirão, por toda a vigência do Contrato, as regras
      estabelecidas pelas Leis nº 12.846/2013 (Lei Anticorrupção) e nº 9.613/1998 (Lei de Lavagem
      de Dinheiro), suas respectivas regulamentações e alterações, e demais legislações
      pertinentes, inclusive no que tange ao combate à corrupção e à vedação à prática de
      qualquer ato lesivo à administração pública, nacional ou estrangeira, bem como declaram,
      sem prejuízo das demais obrigações legais, que não fizeram, farão, instruíram ou instruirão
      a entrega, oferta ou promessa, em interesse ou benefício próprio ou de terceiros, direta ou
      indiretamente, de vantagens indevidas para agentes públicos ou a terceira pessoa a eles
      relacionados.
    </p>
    <p>
      As partes, neste ato, declaram ainda que cumprem e cumprirão, por toda a vigência deste
      Contrato, a legislação e regulamentação referente: (a) à saúde e segurança ocupacional do
      trabalhador e de terceiros; (b) ao meio ambiente; (c) à previdência social; (d)
      à livre concorrência; (e) à defesa do consumidor; (f) aos direitos humanos; bem como
      declaram que suas políticas e atividades não permitem ou incentivam a prática de
      prostituição, atos discriminatórios de qualquer natureza, mão de obra infantil e/ou em
      condição análoga à de escravo.
    </p>

    <h3 className="section">10. Dos Preços</h3>
    <p>
      A plataforma se reserva no direito de reajustar os valores dos serviços ou produtos
      nos termos comerciais definidos entre
      {' '}
      <b>Juristec</b>
      {' '}
      e
      {' '}
      <b>Thomson Reuters</b>
      .
    </p>
    <p>
      Na contratação de determinado serviço ou produto, a plataforma poderá solicitar as
      informações financeiras do usuário, como CPF, endereço de cobrança e dados de cartões. Ao
      inserir referidos dados o usuário concorda que sejam cobrados, de acordo com a forma de
      pagamento que venha a ser escolhida, os preços então vigentes e informados quando da
      contratação. Referidos dados financeiros poderão ser armazenados para facilitar acessos e
      contratações futuras.
    </p>

    <h3 className="section">11. Do Cancelamento</h3>
    <p>
      O usuário poderá cancelar a contratação dos serviços de acordo com os termos que forem
      definidos no momento de sua contratação junto à
      {' '}
      <b>Thomson Reuters</b>
      . Ainda, o usuário também
      poderá cancelar os serviços em até 7 (sete) dias após a contratação, de acordo com o
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        Código de Defesa do Consumidor
      </a>
      {' '}
      (Lei no.
      {' '}
      <a
        href="https://www.jusbrasil.com.br/legislacao/91585/c%C3%B3digo-de-defesa-do-consumidor-lei-8078-90"
        target="_blank"
        rel="noopener noreferrer"
      >
        8.078/90
      </a>
      ), mediante contato com a
      {' '}
      <b>Thomson Reuters</b>
      .
    </p>

    <h3 className="section">12. Jurisdição Para Resolução de Conflitos</h3>
    <p>
      Para a solução de controvérsias decorrentes do presente instrumento será aplicado
      integralmente o direito brasileiro.
    </p>
    <p>
      Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra
      a sede da
      {' '}
      <b>Thomson Reuters</b>
      .
    </p>
  </>
);

export default UseTermsTR;
